export default __webpack_public_path__ + "static/media/ichoice_15.ff266750.jpg";